import React,{useState,useEffect} from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import ClinicServicesForm from './ClinicServicesForm';
const ClinicServicesCard = () => {
    const { register, handleSubmit, formState:{errors} } = useForm();
    const [clinicSettings, setClinicSettings] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { clinicId } = useParams();
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        clinicService.getSettings(clinicId)
            .then(res => {
                setIsLoading(false);
                setIsSuccess(true);
                setIsError(false);
                setErrorMessage('');
                setClinicSettings(res.data);
               
            })
            .catch(err => {
                setIsLoading(false);
                setIsSuccess(false);
                setIsError(true);
                setErrorMessage(err.response.data.message);
                console.log(err);
            });
    }, [clinicId]);

    const updateSettings = (settings)=>{
          setClinicSettings(settings)
    }
    return ( 
        <div className="col-md-8">
             <div className="d-flex justify-content-between">
                   <h5 className="card-title" style={{color:"#012970"}}> Enable/Disable Clinic Services</h5>
                   <div>
                       
                   {isEditing ?
                       <button className="btn btn-secondary btn-sm mt-2"  onClick={()=>setIsEditing(false)}>  
                           <i className="bi bi-x-square bi-sm"></i> Cancel
                       </button>
                       :
                       <button className="btn btn-secondary btn-sm mt-2" onClick={()=>setIsEditing(true)}>  
                       <i className="bi bi-pencil-square bi-sm"></i> Edit
                   </button>
                    }
                       
                   </div>
                 
               </div>
           
          
            <div className="row ms-3">
             {isLoading? <div className="loader"></div>:
               isEditing? <ClinicServicesForm clinicSettings={clinicSettings} updateSettings={updateSettings}/> :
                <>
              <div className="col-sm-5  m-2">
                  <div>
                      {clinicSettings.reminder? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Reminders
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Reminders
                      </span>
                      }
                     
                   </div>
                 
              </div>
              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.recall? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Recall
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Recall
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
                 <div>
                      {clinicSettings.reputation? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Reputation
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Reputation
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.survey? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Surveys
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Surveys
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.surveyReminder? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Survey Reminders
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Survey Reminders
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
                    <div>
                      {clinicSettings.booking? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Booking
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Booking
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.twoWayText? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Two Way Text
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Two Way Text
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
                 <div>
                      {clinicSettings.isAntispamLaw? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Anti spam Law
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Anti Spam Law
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.reminderEmail? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Reminder Email
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Reminder Email
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.reminderCall? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Reminder Call
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Reminder Call
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.reminderSms? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Reminder Sms
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Reminder Sms
                      </span>
                      }
                     
                   </div>
              </div>
              <div className="col-sm-5 m-2">
                     <div>
                      {clinicSettings.newsletterEmail? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Newsletter Email
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Newsletter Email
                      </span>
                      }
                     
                   </div>
              </div>
              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.newsletterSms? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Newsletter Sms
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Newsletter Sms
                      </span>
                      }
                     
                   </div>
              </div>
              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.blastEmail? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Email Blast
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Email Blast
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
              <div>
                      {clinicSettings.blastSms? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Sms Blast
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Sms Blast
                      </span>
                      }
                     
                   </div>
              </div>

              <div className="col-sm-5 m-2">
                    <div>
                      {clinicSettings.blastCall? 
                      <span className="text-success">
                          <i className='bi bi-check-circle-fill'></i> Call Blast
                     </span>
                     :
                     <span className="text-danger">
                            <i className='bi bi-x-circle-fill'></i> Call Blast
                      </span>
                      }
                     
                   </div>
                                 </div>
              <div className="col-sm-5 m-2">
           
              </div>
              </>
}
            </div>
          </div>
     );
}
 
export default ClinicServicesCard;